import { memo } from "react";
import { Icon } from "./Icon";

const AdminIcon = () => {
  return <Icon icon="star" filled color={"#1C1B1F"} size={12} />;
};

export default memo(AdminIcon);
